import React from 'react';
import GooglePlayIcon from './GooglePlayIcon';
import { USER_APP_URL } from '../../config/appLinks';
import { trackEvent } from '../../services/analytics';

/**
 * The one way the site links to the user app.
 *
 * The same four decisions — the URL, the Play icon, `target="_blank"` and
 * `rel="noreferrer"` — were repeated at six call sites, which is how
 * `AccountReadyPage` and `RegisterPage` ended up holding their own copies of the
 * URL and kept pointing at the retired Expo build after the Play Store launch.
 * One component means the next store change is one edit.
 *
 * It also means every placement is measured. Tracking was previously wired by
 * hand at two of the six, so the funnel under-counted install intent by
 * construction.
 */

interface AppStoreLinkProps {
  /** Where this link sits, recorded against the click. */
  placement: string;
  /** Visible label. Defaults to the full store wording. */
  children?: React.ReactNode;
  className?: string;
  /** Extra non-personal detail for the click event. */
  eventParams?: Record<string, string | number | boolean>;
  onClick?: () => void;
}

const AppStoreLink: React.FC<AppStoreLinkProps> = ({
  placement,
  children = 'Get it on Google Play',
  className = 'sw-btn-primary',
  eventParams,
  onClick,
}) => (
  <a
    className={className}
    href={USER_APP_URL}
    onClick={() => {
      trackEvent('app_store_cta', { placement, ...eventParams });
      onClick?.();
    }}
    rel="noreferrer"
    target="_blank"
  >
    <GooglePlayIcon />
    {children}
  </a>
);

export default AppStoreLink;
